import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ListWindow, PageService, TabComponent } from "@xo/client-common";
import { Type13CodeTable } from "./type13Code.table";

@Component({
  selector: "spec-app-type13-code-list-window",
  templateUrl: "./type13Code.list.html",
  styleUrls: ["./type13Code.list.scss"]
})
export class Type13CodeListWindowComponent extends ListWindow {

  @ViewChild("table", { static: false }) table: Type13CodeTable;

  clickHandler: Function;

  constructor(changeDetectorRef: ChangeDetectorRef, private tab: TabComponent, public pageService: PageService) {
    super(changeDetectorRef);
  }

  init(filters?) {
    this.clickHandler = this.pageService.createOpenObject(
      "SpecApp/Type13CodePage",
      this.tab.system,
      (object) => `Type13Code at ID:${object ? object.id : null}`,
      () => ({})
    );
    super.init(filters, this.table);
  }

  reload() {
    console.log("Type13CodeList reload");
    super.reload();
    this.table.refreshList();
  }
}
